import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import logo from './images/logo.png'
import './sytle.css'
const { Header } = Layout

class HeaderTmp extends Component {
    render() {
        return (
            <Header style={{ position: 'fixed', width: '100%', zIndex:9999}} >
                    <div className="logo" >
                        <Link to="/"><img className="logo" src={logo} alt={logo} width={80}/></Link>
                    </div>
                    <Menu 
                        theme="dark"
                        mode="horizontal"
                        style={{ lineHeight: '64px' }}
                    >
                        <Menu.Item key="1"><Link to="/">All Event</Link></Menu.Item>
                        <Menu.Item key="2"><a href="https://ecer.thai.run/" target="_blank" rel="noopener noreferrer">e-Slip</a></Menu.Item>
                        <Menu.Item key="3"><a href="https://thai.run/" target="_blank" rel="noopener noreferrer">Photos</a></Menu.Item>
                    </Menu>
            </Header>
        )
    }
}

export default HeaderTmp


// WEBPACK FOOTER //
// ./src/Template/HeaderTmp.js